import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import addIcon from '../../../assets/svg/add-icon-v2.svg'
import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import saveIcon from '../../../assets/svg/save-icon.svg';


import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import { fi, id, th } from 'react-date-range/dist/locale';
import CustomCalendarFilterSelect from '../../calendar/customCalendarFilterSelect';
import SocialSecurityNumber, { isSocialSecurityNumberValid } from '../../../components/forms/fields/socialSecurityNumber';
import UserIsNotVerifiedTooltip from '../../../components/UserIsNotVerifiedTooltip';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class SearchPatientsField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            }
        };
    }

    getLastOpenedChats = () => {
        fetch(API_ENDPOINT + '/users/patients/last/search', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: this.props.selectedGroup
            })
        }).then(res => res.json()).then((result) => {
            if (result && result.searchItems) {
                this.setState({ lastSearchedPatients: result.searchItems })
            }
        })
    }

    get = () => {

    }

    componentDidMount() {
        this.get();
        this.getLastOpenedChats();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }

    searchPatient = (search, callback) => {
        let obj = {
            socialSecurityNumber: search,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic
        }


        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;
            // console.log('result', result)
            if (result && result._id) {
                // this.props.registerClinicGroupLogs({
                //     type: 'patientProfile',
                //     patient: result.socialSecurityNumber
                // })
                this.setState({ patientData: result })


            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    render() {
        const groupData = this.getGroupData();
        const patientInfoSettings = groupData?.patientInfoSettings || {};


        return (
            <div className='search-patients-field-wrap'>
                <Label>{'Search patient'.translate(this.props.lang)}</Label>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <SocialSecurityNumber
                        hideFindChildren={true}
                        hideDateOfBirth={true}
                        inThisGroup={true}
                        patientInfoSettings={patientInfoSettings}
                        disableNewPatientBtn={true}
                        selectedGroup={this.props.selectedGroup}
                        selectedClinic={this.props.selectedClinic}
                        lang={this.props.lang}
                        country={this.props.country}
                        searchByNameAndEmail={this.state.searchByNameAndEmail || true}
                        searchByNameAndEmailShow={(show) => {
                            this.setState({
                                searchByNameAndEmail: show
                            })
                        }}
                        placeholder={this.props.country === 'denmark' ? 'DDMMYYNNNNN' : this.props.lang === 'en' ? 'YYYYMMDDNNNN' : 'ÅÅÅÅMMDDNNNN'}
                        value={this.state.search}
                        onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                                if (!(!this.state.search || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.search, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                    e.preventDefault();
                                    this.searchPatient(this.state.search)
                                }
                            }
                        }}
                        onChange={(val, callback) => {
                            let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;
                            if (country === 'denmark' && val?.length > 10) {
                                val = val.substr(0, 10);
                            }
                            this.setState({ search: val }, () => {
                                if (callback) {
                                    callback()
                                }
                            })
                        }}
                        newUserCallback={() => {
                            if (!(!this.state.search || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.search, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                this.searchPatient(this.state.search)
                            }
                        }}
                        selectUserCallback={() => {
                            if (!(!this.state.search || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.search, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                this.searchPatient(this.state.search)
                            }
                        }}
                        getCountryState={(countryState) => {
                            let countryStateDict = this.state.countryStateDict ?? {};
                            countryStateDict['search-ssn'] = countryState;
                            this.setState({ countryStateDict })
                        }}
                    />
                    {
                        !this.props.hideSearchBtn ?
                            <Button
                                color="primary"
                                onClick={() => this.searchPatient(this.state.search)}
                                disabled={!this.state.search || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.search, this.state.countryStateDict?.['search-ssn'] ?? this.props.country))}

                                style={{ height: 48 }}
                            >
                                {'Search'.translate(this.props.lang)}
                            </Button>
                            : null
                    }
                </div>
                {
                    this.state.patientData?._id ?
                        <FormGroup style={{ marginTop: 30 }}>
                            <Label>{'Search results'.translate(this.props.lang)}</Label>
                            <div className='patient-search-modal-result' onClick={() => {
                                const patientId = this.state.patientData?._id;
                                if (this.props.setPatient) {
                                    this.props.setPatient(patientId);
                                }
                            }}>
                                <div>
                                    <p>{'Name'.translate(this.props.lang)}</p>
                                    <p className='patient-search-modal-result-text'>{this.state.patientData?.userData?.name ?? this.state.patientData?.name}</p>
                                </div>
                                <div>
                                    <p>{'Social security number'.translate(this.props.lang)}</p>
                                    <p className='patient-search-modal-result-text'>{this.state.patientData?.socialSecurityNumber}</p>
                                </div>
                                {this.state.patientData?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.state.patientData?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified ? <div>
                                    <p>{'Info'.translate(this.props.lang)}</p>
                                    <p className='patient-search-modal-result-text' style={{ textAlign: 'center' }}>
                                        <UserIsNotVerifiedTooltip lang={this.props.lang} />
                                    </p>
                                </div> : (this.state.patientData?.twoFactorAuthentication && Object.keys(this.state.patientData?.twoFactorAuthentication)?.find(key => this.state.patientData?.twoFactorAuthentication?.[key]?.createAccount)) ? <div>
                                    <p>{'Info'.translate(this.props.lang)}</p>
                                    <p className='patient-search-modal-result-text' style={{ textAlign: 'center' }}>
                                        <UserIsNotVerifiedTooltip lang={this.props.lang} warning />
                                    </p>
                                </div> : null}
                            </div>


                        </FormGroup>
                        :
                        null
                }
                {
                    this.state.lastSearchedPatients?.length ?
                        <FormGroup className='search-history-calendar'>
                            <Label>{'Last opened patient profiles / Search history'.translate(this.props.lang)}</Label>
                            <div>
                                <div className="table-h-scroll">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{'Name'.translate(this.props.lang)}</th>
                                                <th>{'Social security number'.translate(this.props.lang)}</th>
                                                <th style={{ paddingLeft: 10 }}>{'Last opened'.translate(this.props.lang)}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.lastSearchedPatients?.map((item, idx) => {
                                                    // console.log('item', item)
                                                    if (idx < 7)
                                                        return (
                                                            <tr
                                                                className='calendar-patient-search-history'
                                                                key={item._id}
                                                                onClick={() => {
                                                                    const patientId = item?._id;
                                                                    if (this.props.setPatient) {
                                                                        this.props.setPatient(patientId);
                                                                    }
                                                                }}
                                                            >
                                                                <td>{item.name}</td>
                                                                <td>{item.socialSecurityNumber}</td>

                                                                <td>{this.props.getStringDateTs(item.timestamp, this.props.dateFormat)}</td>

                                                            </tr>
                                                        )
                                                })
                                            }


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </FormGroup>
                        :
                        null
                }
                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
            </div>
        );
    }
}


export default SearchPatientsField;